import { useMutation } from '@tanstack/react-query'
import { notification } from 'antd'

import { postImpersonate } from 'api/clients'
import { getAuthToken } from 'utils/request'

type ImpersonateOptions = {
  mobile?: boolean
}

export function useImpersonate(clientId: string): (options?: ImpersonateOptions) => Promise<void> {
  const { mutateAsync: loginAs } = useMutation(postImpersonate, {
    onError() {
      notification.error({
        message: 'Unable to impersonate user',
        placement: 'bottomRight',
        duration: 2,
      })
    },
  })

  return async function impersonate({ mobile = false }: ImpersonateOptions = {}) {
    const authToken = getAuthToken()
    const { token } = await loginAs({
      body: { client_id: clientId, token: authToken },
    })
    const target = mobile ? '_self' : '_blank'
    const url = mobile
      ? `community-app-admin://payload?${token}`
      : `${import.meta.env.VITE_DASHBOARD_URL}/impersonate?token=${token}&clientId=${clientId}`
    window.open(url, target)
  }
}
